/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled, { createGlobalStyle } from 'styled-components';

/**
 * Estilização da div
 */
export default styled.div`
  transform: ${({ sideBarIsOpened, theme }) =>
    sideBarIsOpened ? `translateX(-${theme.sideBarNavWidth}vw)` : 'none'};
  width: 100%;
  height: 100%;
  transition: 0.5s transform;

  .page_wrap {
    display: flex;
    height: calc(100vh - 42px ${({ toolBar }) => (toolBar ? '- 42px' : '')});
  }

  @media (max-width: 768px) {
    .page_wrap {
      height: 100%;
    }

    .top_shadow {
      position: absolute;
      z-index: 1100;
      width: 100vw;
      height: 60px;
      background: linear-gradient(
        180deg,
        rgba(31, 45, 77, 0.3) 0%,
        rgba(31, 45, 77, 0) 100%
      );
    }

    .bottom_shadow {
      position: absolute;
      z-index: 1100;
      bottom: 0;
      width: 100vw;
      height: 60px;
      background: linear-gradient(
        0deg,
        rgba(31, 45, 77, 0.3) 0%,
        rgba(31, 45, 77, 0) 100%
      );
    }

    .mobile-cursor {
      position: fixed;
      top: calc(50% - 28px);
      left: calc(50% - 15px);
      width: 30px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1200;
    }
  }

  .mobile-dialog {
    display: none;
    @media (max-width: 768px) {
      display: block;
      position: fixed;
      top: 0;
      width: 100vw;
      height: 100vh;
      z-index: 2000;
      background: #fff;
      .mobile-dialog-content {
        height: calc(100% - 66px);
        width: 100%;
        overflow: auto;
      }
    }
  }
`;

/**
 * Estilização do componente GlobalStyle
 */
export const GlobalStyle = createGlobalStyle`

  html{
    overflow-x: hidden;
  }
  
  body{
    font-family: Roboto;
  }

  *{
    outline:none
  }

  .leaflet-control-attribution {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1; 
    -webkit-box-orient: vertical;
    margin: 0 10px !important;
  }

  .leaflet-transparent-tooltip {
    font-family: Roboto;
    font-style: normal;
    background: transparent;
    text-shadow: -1px 0 0 white, -1px -1px 0 white, 0 -1px 0 white,
    1px -1px 0 white, 1px 0 0 white, 1px 1px 0 white, 0 1px 0 white,
    -1px 1px 0 white;
    border: none;
    box-shadow: none;
  }

  .leaflet-transparent-tooltip::before {
    background: transparent;
    border: none;
    box-shadow: none;
  }

  
  /* 
   * Customização dos balões popup de camadas JPG/JPEG 
   */
  .custom-leaflet-popup-jpg-jpeg-layer .leaflet-popup-tip,
  .custom-leaflet-popup-jpg-jpeg-layer .leaflet-popup-content-wrapper {
    background: #fff;
    color: #fff;    
    border-radius: 6px;
  }

  .custom-leaflet-popup-jpg-jpeg-layer .leaflet-popup-content {
    margin: 6px 6px;
  }

  .custom-leaflet-popup-jpg-jpeg-layer .leaflet-popup-content .container-img {
    position: relative;   
  }

  .custom-leaflet-popup-jpg-jpeg-layer .leaflet-popup-content .container-img:hover .container-buttons {
    display: block;
  }

  .custom-leaflet-popup-jpg-jpeg-layer .leaflet-popup-content .container-buttons {
    float: right;
    position: absolute;   
    right: 0;  
    top: 0; 
    background-color: rgba(0, 0, 0, 0.6);
    width: 55px;
    height: 34px;    
    display: none;
  }

  .custom-leaflet-popup-button-maximize {
    background: none;
    border: none;    
    display: inline;
    width: 28px;
    height: 33px;
    padding-left: 11px;
    padding-top: 1px;
  }

  .custom-leaflet-popup-button-close {
    background: none;
    border: none;    
    display: inline;
    width: 27px;
    height: 33px;
    padding-right: 7px;
  }

  /*  --------------------------------  */

  @media (min-width: 768px) {
    &::-webkit-scrollbar{
      width: 15px;
    }
    &::-webkit-scrollbar-track{
      box-shadow: inset 0 0 6px rgba(0,0,0,0.00);
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.00);
    }
    &::-webkit-scrollbar-thumb{
      background-color: #C4C4C4;
      width:15px;
      border: 5px solid white;
      border-radius:10px;
      min-height: 96px;
    }
    .gba-data {
      ::-webkit-scrollbar-thumb {
        border: 5px solid #f0f0f0 
      }
    }
  }

  @media (max-width: 768px) {
    html, body, #root {
      height: 100%;
    }
  }
`;
